import React, {Component} from "react"
import {makeStyles} from "@material-ui/core/styles"
import {CssBaseline} from "@material-ui/core"

const appBarHeight = 64
const mobileAppBarHeight = 56

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
	},
	appBarSpacer: theme.mixins.toolbar,
	blueBar: {
		backgroundColor: "#003d4d",
		alignContent: "center",
		verticalAlign: "middle",
		marginTop: appBarHeight,
		flex: "auto",
		textAlign: "center",
		fontSize: "1.4rem",
		fontWeight: "400",
		color: "white",
		height: "auto",
		padding: "1%",
		[theme.breakpoints.down("md")]: {
			marginTop: mobileAppBarHeight,
		},
	},
}))

function BlueBar() {
	const classes = useStyles()

	return (
		<div className={classes.root}>
			<CssBaseline />
			<div className={classes.appBarSpacer} />
			<div className={classes.blueBar}>
				<span className={classes.blueBarTitle}>
					Добре дошли в BIODIT MANAGEMENT SOFTWARE
				</span>
			</div>
		</div>
	)
}

export default BlueBar

// export default connect(
//     mapStateToProps,
//     { logoutUser }
// )(Dashboard)
